import type { ISessionRepository, SessionSearchOptions } from '../repositories/ISessionRepository.js';
import type { SessionEntity } from '../entities/SessionEntity.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createSearchSessionsUseCase({ sessionRepository }: Deps) {
  return async function searchSessions(options: SessionSearchOptions): Promise<{ data: SessionEntity[]; total: number }> {
    return sessionRepository.search(options);
  };
}
